/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { getLocations, addLocation, deleteLocation, addScreen, deleteScreen, assignPlaylist, getPlaylists, getAdminUsers, updateOrientation } from '../api';
import { supabase } from '../supabase';

export default function Locations() {
  const [locations, setLocations] = useState([]);
  const [playlists, setPlaylists] = useState([]);
  const [selected, setSelected] = useState(null);
  const [newLoc, setNewLoc] = useState({ name: '', type: 'Cafe' });
  const [newScr, setNewScr] = useState({ name: '', playlist_id: '' });
  const [showLocForm, setShowLocForm] = useState(false);
  const [showScrForm, setShowScrForm] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userMap, setUserMap] = useState({});
  const [filterType, setFilterType] = useState('all');
  const [filterUser, setFilterUser] = useState('all');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    supabase.auth.getUser().then(({ data: { user } }) => {
      if (user && user.id === process.env.REACT_APP_ADMIN_USER_ID) {
        setIsAdmin(true);
        getAdminUsers().then(res => {
          const map = {};
          res.data.forEach(u => { map[u.id] = u; });
          setUserMap(map);
        });
      }
    });
  }, []);

  const load = async () => {
    const res = await getLocations();
    setLocations(res.data);
    if (!selected && res.data.length > 0) setSelected(res.data[0]);
    const pl = await getPlaylists();
    setPlaylists(pl.data);
  };

  useEffect(() => { load(); }, []);

  const handleAddLoc = async () => {
    if (!newLoc.name) return;
    await addLocation(newLoc);
    setNewLoc({ name: '', type: 'Cafe' });
    setShowLocForm(false);
    load();
  };

  const handleAddScr = async () => {
    if (!newScr.name || !selected) return;
    await addScreen({ location_id: selected.id, name: newScr.name, playlist_id: newScr.playlist_id || null });
    setNewScr({ name: '', playlist_id: '' });
    setShowScrForm(false);
    load();
  };

  const handleOrientationChange = async (scrId, orientation) => {
    await updateOrientation(scrId, orientation);
    setLocations(prev => prev.map(loc => ({
      ...loc,
      screens: (loc.screens || []).map(scr => scr.id === scrId ? { ...scr, orientation } : scr)
    })));
  };

  const selectedLoc = locations.find(l => l.id === selected?.id);
  const TYPES = [...new Set(locations.map(l => l.type).filter(Boolean))].sort();
  const filtered = locations.filter(loc => {
    const typeMatch = filterType === 'all' || loc.type === filterType;
    const userMatch = filterUser === 'all' || loc.user_id === filterUser;
    return typeMatch && userMatch;
  });
  const usersInLocations = [...new Set(locations.map(l => l.user_id).filter(Boolean))];

  return (
    <div style={{ background: '#F8F6F3', minHeight: '100%' }}>
      {/* Page header */}
      <div style={hdr}>
        <div>
          <h1 style={title}>Locations</h1>
          {isAdmin && <span style={adminBadge}>Admin View</span>}
        </div>
        <button onClick={() => setShowLocForm(!showLocForm)} style={btnPrimary}>+ Add Location</button>
      </div>

      <div style={{ padding: '16px 24px' }}>
        {/* Filters */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
          <select value={filterType} onChange={e => setFilterType(e.target.value)} style={selectSt}>
            <option value="all">All types ({locations.length})</option>
            {TYPES.map(t => { const c = locations.filter(l => l.type === t).length; return c > 0 ? <option key={t} value={t}>{t} ({c})</option> : null; })}
          </select>
          {isAdmin && (
            <select value={filterUser} onChange={e => setFilterUser(e.target.value)} style={selectSt}>
              <option value="all">All customers</option>
              {usersInLocations.map(uid => { const u = userMap[uid]; const c = locations.filter(l => l.user_id === uid).length; return <option key={uid} value={uid}>{u?.email || uid} ({c})</option>; })}
            </select>
          )}
          {(filterType !== 'all' || filterUser !== 'all') && (
            <button onClick={() => { setFilterType('all'); setFilterUser('all'); }} style={btnGhost}>Clear</button>
          )}
          <span style={{ fontSize: 12, color: '#aaa' }}>{filtered.length} location{filtered.length !== 1 ? 's' : ''}</span>
        </div>

        {/* Add location form */}
        {showLocForm && (
          <div style={formCard}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12, color: '#555' }}>New Location</div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
              <input placeholder="Location name" value={newLoc.name} onChange={e => setNewLoc({ ...newLoc, name: e.target.value })} style={{ ...inp, flex: '1 1 180px' }} />
              <select value={newLoc.type} onChange={e => setNewLoc({ ...newLoc, type: e.target.value })} style={{ ...inp, flex: '0 0 140px' }}>
                {['Cafe', 'Restaurant', 'Shop', 'Hotel', 'Office', 'Other'].map(t => <option key={t}>{t}</option>)}
              </select>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={handleAddLoc} style={btnPrimary}>Add</button>
              <button onClick={() => setShowLocForm(false)} style={btnGhost}>Cancel</button>
            </div>
          </div>
        )}

        {/* Locations */}
        {isMobile ? (
          <div>
            {filtered.map(loc => {
              const screens = loc.screens || [];
              const online = screens.filter(s => s.is_online).length;
              const isSelected = selected?.id === loc.id;
              return (
                <div key={loc.id} onClick={() => setSelected(loc)}
                  style={{ ...locCard, border: isSelected ? '1.5px solid #8B1E2D' : '1px solid #E8E3DC', background: isSelected ? '#FDF5F6' : '#fff' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 14, color: '#1A1A1A' }}>{loc.name}</div>
                      <div style={{ display: 'flex', gap: 6, marginTop: 5, flexWrap: 'wrap', alignItems: 'center' }}>
                        <span style={typePill}>{loc.type}</span>
                        <span style={{ fontSize: 12, color: '#888' }}>{screens.length} screen{screens.length !== 1 ? 's' : ''}</span>
                        {online > 0 && <span style={{ fontSize: 12, color: '#2D6A4F' }}>🟢 {online} online</span>}
                      </div>
                      {isAdmin && userMap[loc.user_id] && <div style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>{userMap[loc.user_id]?.email}</div>}
                    </div>
                    <button onClick={e => { e.stopPropagation(); deleteLocation(loc.id).then(load); }} style={btnDanger}>Delete</button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div style={tableWrap}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #E8E3DC' }}>
                  <th style={th}>Location</th>
                  <th style={th}>Type</th>
                  {isAdmin && <th style={th}>Customer</th>}
                  <th style={{ ...th, textAlign: 'center' }}>Screens</th>
                  <th style={{ ...th, textAlign: 'center' }}>Online</th>
                  <th style={th}></th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((loc, i) => {
                  const screens = loc.screens || [];
                  const online = screens.filter(s => s.is_online).length;
                  const u = userMap[loc.user_id];
                  const isSelected = selected?.id === loc.id;
                  return (
                    <tr key={loc.id} onClick={() => setSelected(loc)}
                      style={{ borderBottom: '1px solid #F0EBE4', background: isSelected ? '#FDF5F6' : i % 2 === 0 ? '#fff' : '#FAFAF9', cursor: 'pointer', transition: 'background 0.1s' }}>
                      <td style={{ ...td, fontWeight: 600 }}>
                        {loc.name}
                        {isSelected && <span style={{ fontSize: 10, color: '#8B1E2D', marginLeft: 6, fontWeight: 400 }}>● selected</span>}
                      </td>
                      <td style={td}><span style={typePill}>{loc.type}</span></td>
                      {isAdmin && <td style={{ ...td, color: '#777', fontSize: 12 }}>{u?.email || '—'}</td>}
                      <td style={{ ...td, textAlign: 'center', color: '#555' }}>{screens.length}</td>
                      <td style={{ ...td, textAlign: 'center' }}>
                        <span style={{ color: online > 0 ? '#2D6A4F' : '#aaa', fontWeight: 500 }}>
                          {online > 0 ? `🟢 ${online}` : '—'}
                        </span>
                      </td>
                      <td style={{ ...td, textAlign: 'right' }} onClick={e => e.stopPropagation()}>
                        <button onClick={() => deleteLocation(loc.id).then(load)} style={btnDanger}>Delete</button>
                      </td>
                    </tr>
                  );
                })}
                {filtered.length === 0 && (
                  <tr><td colSpan={isAdmin ? 6 : 5} style={{ padding: 32, textAlign: 'center', color: '#aaa', fontSize: 14 }}>No locations yet.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {/* Screens panel */}
        {selectedLoc && (
          <div style={{ marginTop: 24 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#1A1A1A' }}>Screens — {selectedLoc.name}</div>
                {isAdmin && userMap[selectedLoc.user_id] && <div style={{ fontSize: 11, color: '#aaa', marginTop: 2 }}>{userMap[selectedLoc.user_id]?.email}</div>}
              </div>
              <button onClick={() => setShowScrForm(!showScrForm)} style={btnSecondary}>+ Add Screen</button>
            </div>

            {showScrForm && (
              <div style={{ ...formCard, marginBottom: 12 }}>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
                  <input placeholder="Screen name" value={newScr.name} onChange={e => setNewScr({ ...newScr, name: e.target.value })} style={{ ...inp, flex: '1 1 180px' }} />
                  <select value={newScr.playlist_id} onChange={e => setNewScr({ ...newScr, playlist_id: e.target.value })} style={{ ...inp, flex: '1 1 180px' }}>
                    <option value="">Select playlist</option>
                    {playlists.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                  </select>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={handleAddScr} style={btnPrimary}>Add</button>
                  <button onClick={() => setShowScrForm(false)} style={btnGhost}>Cancel</button>
                </div>
              </div>
            )}

            {(selectedLoc.screens || []).length === 0 && (
              <div style={{ background: '#fff', border: '1px dashed #E8E3DC', borderRadius: 10, padding: '24px', textAlign: 'center', color: '#aaa', fontSize: 14 }}>
                No screens yet. Add a screen to get started.
              </div>
            )}

            {(selectedLoc.screens || []).map(scr => (
              <div key={scr.id} style={{ ...locCard, marginBottom: 8 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{scr.name}</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ fontSize: 12, color: scr.is_online ? '#2D6A4F' : '#aaa', fontWeight: 500 }}>
                      {scr.is_online ? '🟢 Online' : '⚫ Offline'}
                    </span>
                    <button onClick={() => deleteScreen(scr.id).then(load)} style={btnDanger}>Delete</button>
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 10 }}>
                  <div>
                    <label style={fieldLabel}>Playlist</label>
                    <select value={scr.playlist_id || ''} onChange={e => assignPlaylist(scr.id, e.target.value).then(load)}
                      style={{ ...inp, fontSize: 13 }}>
                      <option value="">— None —</option>
                      {playlists.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={fieldLabel}>Orientation</label>
                    <div style={{ display: 'flex', gap: 6 }}>
                      {['landscape', 'portrait'].map(o => (
                        <button key={o} onClick={() => handleOrientationChange(scr.id, o)}
                          style={{ flex: 1, padding: '7px 8px', borderRadius: 7, border: '1px solid #E8E3DC', fontSize: 12, cursor: 'pointer', fontWeight: 500,
                            background: (scr.orientation || 'landscape') === o ? '#111' : '#fff',
                            color: (scr.orientation || 'landscape') === o ? '#fff' : '#555' }}>
                          {o === 'landscape' ? '↔ Landscape' : '↕ Portrait'}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
                <div style={{ fontSize: 10, color: '#ccc', fontFamily: 'monospace', wordBreak: 'break-all' }}>{scr.device_token}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const hdr = { background: '#fff', borderBottom: '1px solid #E8E3DC', padding: '14px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, zIndex: 10 };
const title = { fontSize: 18, fontWeight: 700, color: '#1A1A1A', margin: 0, display: 'inline' };
const adminBadge = { fontSize: 11, background: '#FDE8E8', color: '#8B1E2D', padding: '2px 8px', borderRadius: 20, marginLeft: 8, fontWeight: 500 };
const btnPrimary = { background: '#8B1E2D', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer' };
const btnSecondary = { background: '#fff', color: '#444', border: '1px solid #E8E3DC', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 500, cursor: 'pointer' };
const btnDanger = { background: '#fff', color: '#9B2335', border: '1px solid #F5C6CB', borderRadius: 7, padding: '5px 12px', fontSize: 12, fontWeight: 500, cursor: 'pointer' };
const btnGhost = { background: 'none', color: '#888', border: '1px solid #E8E3DC', borderRadius: 8, padding: '8px 14px', fontSize: 13, cursor: 'pointer' };
const selectSt = { padding: '7px 10px', border: '1px solid #E8E3DC', borderRadius: 8, fontSize: 13, cursor: 'pointer', background: '#fff', color: '#333' };
const inp = { width: '100%', padding: '8px 12px', border: '1px solid #E8E3DC', borderRadius: 8, fontSize: 13, outline: 'none', boxSizing: 'border-box', background: '#FAFAF9' };
const formCard = { background: '#fff', border: '1px solid #E8E3DC', borderRadius: 10, padding: '16px', marginBottom: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.04)' };
const locCard = { background: '#fff', border: '1px solid #E8E3DC', borderRadius: 10, padding: '14px 16px', marginBottom: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.04)' };
const tableWrap = { background: '#fff', border: '1px solid #E8E3DC', borderRadius: 10, overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.04)', marginBottom: 8 };
const th = { padding: '10px 16px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#888', background: '#FAFAF9', letterSpacing: 0.3 };
const td = { padding: '11px 16px', color: '#333' };
const typePill = { fontSize: 11, background: '#F0EBE4', color: '#666', padding: '2px 8px', borderRadius: 20, fontWeight: 500 };
const fieldLabel = { fontSize: 11, color: '#888', display: 'block', marginBottom: 5, fontWeight: 500 };